<template lang="pug">
  #wrapper
    nav(role="navigation").navbar-default.navbar-static-side
      .sidebar-collapse
        ul#side-menu.nav.metismenu
          li(:class="currPage == 'all' ? 'active' : ''")
            router-link(to="/all")
              i.fa.fa-sun-o
              span.nav-label All

          li(:class="currPage == 'condo' ? 'active' : ''")
            router-link(to="/condo")
              i.fa.fa-building-o
              span.nav-label Condo
              i.fa.arrow
            ul.nav.nav-second-level
              li(:class="$route.path.split('/')[2] == 'sale' ? 'active' : ''")
                router-link(to="/condo/sale") Sale
              li(:class="$route.path.split('/')[2] == 'rent' ? 'active' : ''")
                router-link(to="/condo/rent") Rent
              li(v-if="$ls.get('user').role_name == 'Super Admin'" :class="$route.path.split('/')[2] == 'name' ? 'active' : ''")
                router-link(to="/condo/name") Project Name

          li(:class="currPage == 'house' ? 'active' : ''")
            router-link(to="/house")
              i.fa.fa-home
              span.nav-label House
              i.fa.arrow
            ul.nav.nav-second-level
              li(:class="$route.path.split('/')[2] == 'sale' ? 'active' : ''")
                router-link(to="/house/sale") Sale
              li(:class="$route.path.split('/')[2] == 'rent' ? 'active' : ''")
                router-link(to="/house/rent") Rent

          li(:class="currPage == 'townhouse' ? 'active' : ''")
            router-link(to="/townhouse")
              i.fa.fa-building
              span.nav-label Townhouse
              i.fa.arrow
            ul.nav.nav-second-level
              li(:class="$route.path.split('/')[2] == 'sale' ? 'active' : ''")
                router-link(to="/townhouse/sale") Sale
              li(:class="$route.path.split('/')[2] == 'rent' ? 'active' : ''")
                router-link(to="/townhouse/rent") Rent

          li(:class="currPage == 'land' ? 'active' : ''")
            router-link(to="/land")
              i.fa.fa-map-signs
              span.nav-label Land
              i.fa.arrow
            ul.nav.nav-second-level
              li(:class="$route.path.split('/')[2] == 'sale' ? 'active' : ''")
                router-link(to="/land/sale") Sale
              li(:class="$route.path.split('/')[2] == 'rent' ? 'active' : ''")
                router-link(to="/land/rent") Rent

          li(:class="currPage == 'building' ? 'active' : ''")
            router-link(to="/building")
              i.fa.fa-building-o
              span.nav-label Building
              i.fa.arrow
            ul.nav.nav-second-level
              li(:class="$route.path.split('/')[2] == 'sale' ? 'active' : ''")
                router-link(to="/building/sale") Sale
              li(:class="$route.path.split('/')[2] == 'rent' ? 'active' : ''")
                router-link(to="/building/rent") Rent

          li(v-if="$ls.get('user').role_id == '1'" :class="currPage == 'users' ? 'active' : ''")
            router-link(to="/users")
              i.fa.fa-users
              span.nav-label Users

    #page-wrapper.gray-bg.dashbard-1
      .row.border-bottom
        .navbar.navbar-static-top(role="navigation" style="margin-bottom: 0")
          .navbar-header
            a(@click="toggleMiniNavbar").navbar-minimalize.minimalize-styl-2.btn.btn-primary: i.fa.fa-bars
          ul.nav.navbar-top-links.navbar-right
            li
              span.m-r-sm.text-muted {{ $ls.get('user').username }} ({{ $ls.get('user').role_name }})
            li
              router-link(to="/logout") <i class="fa fa-sign-out"></i> Log out

      .row.wrapper.border-bottom.white-bg.page-heading
        .col-lg-10
          h2 {{ currPage }} Management
          //- ol.breadcrumb
            li: a(href="#") Home
            li: a Tables
            li.active: strong Tables

      router-view
</template>

<script>
  import axios from 'axios'
  import $ from 'jquery'

  global.baseUrl = 'https://www.agentbkk.com/'

  export default {
    data () {
      return {
        currPage: this.$route.path.split('/')[1],
        links: []
      }
    },
    watch: {
      '$route' (to, from) {
        this.currPage = to.path.split('/')[1]
        $('.body-small').removeClass('mini-navbar')
      }
    },
    beforeCreate () {
      if (this.$ls.get('token', false)) axios.defaults.headers.common['Authorization'] = this.$ls.get('token')
      else this.$router.push('/login')
    },
    created () {
      console.log(this.$ls.get('user'))
    },
    mounted () {
      $(function () {
        toggleBodySmall()
        $(window).resize(function () {
          toggleBodySmall()
        })
        function toggleBodySmall () {
          if ($(window).width() < 784) $('body').addClass('body-small')
          else $('body').removeClass('body-small')
        }
      })
    },
    methods: {
      toggleMiniNavbar () {
        $('body').toggleClass('mini-navbar')
      },
      fetchLinks () {
        axios.get('project/menu').then((res) => {
          console.log(res.data)
        })
      }
    }
  }
</script>

<style lang="less" scoped>

  h2 {
    text-transform: capitalize;
  }

  .nav {

    li {

      &.active {
        // border-left: 4px solid #032a51;
      }

      a {

        .fa {
          @media (max-width: 768px) {
            margin: 0;
          }
        }

        .nav-label {
          padding-left: 5px;

          @media (max-width: 768px) {
            font-size: 9px;
            padding: 0;
            display: block !important;
          }
        }

        @media (max-width: 768px) {
          font-size: 14px;
          padding: 14px 0px 14px 0px;
          text-align: center;

          .arrow {
            display: none;
          }
        }
      }

      .nav-second-level {
        overflow: hidden;
        height: 0;
        text-align: left;
      }

      &.active {
        .nav-second-level {
          height: auto;

          @media (max-width: 768px) {
            display: block;
            width: 200px;
          }
        }
      }
    }
  }

  .mini-navbar {
    .arrow {
      display: none;
    }
  }
</style>

<style lang="less">

  body {
    &.hasModal {
      overflow: hidden;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    color: #555 !important;
  }

  .text-primary {
    color: #032a51;
  }

  .btn {
    &.btn-primary {
      background-color: #032a51;
      border-color: #032a51;
    }

    &.btn-link {
      color: #1ab394;
    }
  }

  // Autocomplete
  .v-autocomplete-list {
    width: 100%;
    border-left: 1px solid #EEE;
    border-right: 1px solid #EEE;
    z-index: 1000;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);

    .v-autocomplete-list-item {
      border-bottom: 1px solid #EEE;
      width: 100%;
      background-color: white;
      padding: 5px 10px 3px;

      &:hover {
        background-color: #EEE;
      }
    }
  }

  // Modal
  .v--modal {
    background-color: transparent !important;
  }

  // Nav tab

  .nav.nav-tabs {
    li {
      @media(max-width: 425px) {
        background: white;
        margin-bottom: 3px;
      }

      &.active {
        a, a:hover {
          @media(max-width: 425px) {
            background-color: #032a51 !important;
            color: white;
            border-radius: 0;
          }
        }
      }
    }
  }

  .btn {
    &.btn-link {
      color: #032a51;
    }
  }

  .form-control:focus, .has-success .form-control, .has-success .form-control:focus, .single-line:focus {
    border-color: #032a51;
  }

  .product-box {

    .ibox-content {
      padding: 0;
    }

    hr {
      margin: 10px 0;
    }

    .product-desc {

      div {
        padding: 2px 0;
      }

      .price {
        font-size: 25px;
      }
    }
  }

  .created-meta {
    span {
      margin: 0 5px;
    }
  }

  .widget {
    margin: 0;
  }

  .project-image {
    position: relative;
    overflow: hidden;
    margin-bottom: 10px;

    @media (max-width: 425px) {
      max-height: 355px;
    }

    @media (max-width: 375px) {
      max-height: 305px;
    }

    @media (max-width: 320px) {
      max-height: 250px;
    }

    .pin {
      position: absolute;
      top: 10px;
      left: 10px;
      font-size: 20px;
      color: gold;
      text-shadow: 0 0 8px rgba(0, 0, 0, 0.35);
    }

    .day-left {
      position: absolute;
      right: 0;
      bottom: 0;
      color: white;
      background-color: rgba(0, 0, 0, 0.35);
      padding: 3px 10px;
      font-size: 12px;
    }
    .multi-image {
      position: absolute;
      top: 10px;
      right: 10px;
      color: white;
      text-shadow: 0 0 8px rgba(0, 0, 0, 0.35);
      font-size: 20px;
    }
  }

  .filter-project {
    overflow: hidden;
    height: auto;
    transition: height 0.2s ease-out;

    &.hide {
      height: 0;
    }
  }

  .product-detail {
    .ibox-content {
      padding: 10px;
    }

    .product-btn-group {
      .btn {
        margin: 0 5px 5px;
      }
    }
  }

  .pagination {
    margin: 0;
  }
</style>




// WEBPACK FOOTER //
// index.vue?193e17ad